const TABS = [
  ["news",       "#NEWS"],
  ["unverified", "#UNVERF"],
  ["deeper",     "#DEEPER"],
  ["idea",       "#IDEA"],
  ["anchor",     "#ANCHOR"],
];

export default function TabBar({ activeTab, onTabChange }) {
  return (
    <div className="flex border-b border-border-line flex-shrink-0">
      {TABS.map(([id, label]) => (
        <button
          key={id}
          onClick={() => onTabChange(id)}
          className={`flex-1 min-h-[44px] py-2 bg-transparent border-none cursor-pointer
            text-[10px] tracking-[0.12em] uppercase whitespace-nowrap
            transition-colors duration-100
            ${activeTab === id
              ? "font-extrabold text-text-primary border-b-[1.5px] border-text-primary"
              : "font-medium text-text-tertiary border-b-[1.5px] border-transparent"
            }`}
        >
          {label}
        </button>
      ))}
    </div>
  );
}
